import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { IoMenu, IoClose } from "react-icons/io5";
import { CSSTransition } from 'react-transition-group';
import './menu.css';
import DenniNabidkaModal from '../denni_nabidka/denni-nabidka-modal.tsx';

//IKONY
import { FaRegNewspaper } from "react-icons/fa"; //AKTUALITY
import { AiFillHome } from "react-icons/ai"; //DOMŮ
import { GiForkKnifeSpoon } from "react-icons/gi"; //DENNÍ MENU
import { MdRestaurantMenu } from "react-icons/md"; //JÍDELNÍ LÍSTEK
import { FaBed } from "react-icons/fa"; //UBYTOVÁNÍ
import { AiOutlinePhone } from "react-icons/ai"; //KONTAKT
import { FaImages } from "react-icons/fa"; //GALERIE / FOTOGALERIE
import { FaCalendarCheck } from "react-icons/fa"; //REZERVACE
import { FaBuilding } from "react-icons/fa"; //FIRMY
import { GiDiamondRing } from "react-icons/gi"; //SVATBY
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

function MenuMobile() {
  const [bool, setBool] = useState(0);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [denniOpen, setDenniOpen] = useState(false);

  const toggleBool = () => {
    setBool(bool === 0 ? 1 : 0);
  };

  const closeMenu = () => setBool(0);

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  useEffect(() => {
    document.body.style.overflow = bool === 1 ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [bool]);

  return (
    <div>
      <IoMenu id='hlavni-ikona-menu-mobile' className="ikona" onClick={toggleBool} />

      <CSSTransition
        in={bool === 1}
        timeout={500}
        classNames="fade"
        unmountOnExit
      >
        <div className="inside">
          <div className="menu-panel">
            <div className="menu-top">
              <span className="menu-brand">Hospůdka pod Rablinů</span>
              <button type="button" className="menu-close" aria-label="Zavřít menu" onClick={closeMenu}>
                <IoClose />
              </button>
            </div>

            <nav className="menu-nav">
              <button
                type="button"
                className="menu-row featured"
                style={{ '--i': 0 }}
                onClick={() => {
                  closeMenu();
                  setDenniOpen(true);
                }}
              >
                <span className="menu-ic"><GiForkKnifeSpoon /></span>
                <span className="menu-text">
                  <span className="menu-name">Denní nabídka</span>
                  <span className="menu-sub">Dnešní polévka a hlavní jídla</span>
                </span>
                <FaChevronRight className="menu-caret-right" />
              </button>

              <Link className="menu-row" style={{ '--i': 1 }} to="/" onClick={closeMenu}>
                <span className="menu-ic"><AiFillHome /></span>
                <span className="menu-name">Domů</span>
              </Link>

              <Link className="menu-row" style={{ '--i': 2 }} to="/aktuality" onClick={closeMenu}>
                <span className="menu-ic"><FaRegNewspaper /></span>
                <span className="menu-name">Aktuality</span>
              </Link>

              <Link className="menu-row" style={{ '--i': 3 }} to="/jidelni-listek" onClick={closeMenu}>
                <span className="menu-ic"><MdRestaurantMenu /></span>
                <span className="menu-text">
                  <span className="menu-name">Jídelní lístek</span>
                  <span className="menu-sub">Stálá nabídka</span>
                </span>
              </Link>

              <Link className="menu-row" style={{ '--i': 4 }} to="/svatby" onClick={closeMenu}>
                <span className="menu-ic"><GiDiamondRing /></span>
                <span className="menu-name">Svatby</span>
              </Link>

              <Link className="menu-row" style={{ '--i': 5 }} to="/firmy" onClick={closeMenu}>
                <span className="menu-ic"><FaBuilding /></span>
                <span className="menu-name">Firmy</span>
              </Link>

              <div className="submenu-container" style={{ '--i': 6 }}>
                <button type="button" className="menu-row" onClick={toggleSubmenu}>
                  <span className="menu-ic"><FaBed /></span>
                  <span className="menu-name">Ubytování</span>
                  <FaChevronDown className={`menu-caret ${submenuOpen ? "open" : ""}`} />
                </button>

                <CSSTransition
                  in={submenuOpen}
                  timeout={300}
                  classNames="submenu-fade"
                  unmountOnExit
                >
                  <div className="submenu">
                    <Link to="/ubytovani" onClick={closeMenu}>Pokoje</Link>
                    {/* <Link to="/balicky">Cenové balíčky</Link> */}
                  </div>
                </CSSTransition>
              </div>

              <Link className="menu-row" style={{ '--i': 7 }} to="/fotogalerie" onClick={closeMenu}>
                <span className="menu-ic"><FaImages /></span>
                <span className="menu-name">Galerie</span>
              </Link>

              <Link className="menu-row" style={{ '--i': 8 }} to="/kontakt" onClick={closeMenu}>
                <span className="menu-ic"><AiOutlinePhone /></span>
                <span className="menu-name">Kontakt</span>
              </Link>
            </nav>

            <div className="menu-footer">
              <Link className="menu-cta" to="/rezervace" onClick={closeMenu}>
                <FaCalendarCheck /> Rezervovat
              </Link>
              <Link className="menu-cta ghost" to="/kontakt" onClick={closeMenu}>
                Mapa
              </Link>
            </div>
          </div>
        </div>
      </CSSTransition>

      <DenniNabidkaModal open={denniOpen} onClose={() => setDenniOpen(false)} />
    </div>
  );
}

export default MenuMobile;
